import { render, staticRenderFns } from "./message-bubble.vue?vue&type=template&id=2a13915d&scoped=true"
import script from "./message-bubble.vue?vue&type=script&lang=js"
export * from "./message-bubble.vue?vue&type=script&lang=js"
import style0 from "./message-bubble.vue?vue&type=style&index=0&id=2a13915d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a13915d",
  null
  
)

export default component.exports